
export const MapViewStyles = {
  height: "100%",
  minHeight: "320px",
  position: "relative",

  '& .leaflet-container': {
    height: "100%",
    zIndex: 0,
  },
  '& .leaflet-tooltip': {
    fontSize: ".7rem",
    width: {
      xs: "230px",
      md: "280px"
    },
    whiteSpace: "normal",
  },
  '.custom-groups__filters-form &': {
    height: "auto",
  },
  '.dashboard-page.labor &': {
    height: "auto",
  }

}
